//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyFileController_updateOneById,
  Response$AdminCompanyFileController_updateOneById$Status$200,
  ResponseContentType$AdminCompanyFileController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminCompanyFileController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminCompanyFileController_updateOneById,
    Response$AdminCompanyFileController_updateOneById$Status$200[ResponseContentType$AdminCompanyFileController_updateOneById]
  >({ method: 'AdminCompanyFileController_updateOneById' });
